import { MCBHS020InitRequest } from 'types/MCBHS020/MCBHS020InitRequest'
import { MCBHS020RegisterRequest } from 'types/MCBHS020/MCBHS020RegisterRequest'
import request from 'utils/request'

export const initRequest = (apiData: MCBHS020InitRequest) => {
  return request({
    url: '/MCBHS020/init',
    method: 'post',
    data: apiData,
  })
}
export const redistRequest = (
  apiData: MCBHS020RegisterRequest,
  files: any[]
) => {
  const data = new FormData()
  data.append('sendRegister', encodeURIComponent(JSON.stringify(apiData)))
  const attachmentList = files
  if (attachmentList) {
    attachmentList.map(attachment => {
      if (attachment) {
        data.append('attachment', attachment)
      }
    })
  }

  return request({
    url: '/MCBHS020/sendRegister',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
